import { IHh as IHhState } from '../../types/hh';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

const INITIAL_STATE: IHhState = {
  queryParams: { siteId: '', clickId: '' },
  isHidden: false,
};

export const hhReducer = createNoopReducer<IHhState>(INITIAL_STATE);
